import {SamplingPointCounts} from '../../types'

import {Api} from '@settings/api'

export const SAMPLING_POINTS_COUNTS_QUERY_KEY = 'samplingPointsCounts'

export async function samplingPointsCounts(plantCode: string): Promise<SamplingPointCounts[]> {
  const path = `cement-quality/plants/${plantCode}/sampling-point-statistics`
  const response = await Api.axiosInstance.get<SamplingPointCounts[]>(path)
  return response.data
}
